import { CharterInvoiceAuthorizationStateEnum } from './charter-invoice-authorization-state-enum';

export class SalesUploadedDocument {
  active: boolean;
  createTime: Date;
  documentId: number = null;
  documentTypeId: CharterInvoiceAuthorizationStateEnum = null;
  generateTime: Date;
  grayedOut: boolean = null;
  invoiceId: number;
  legacyFormUrlKey: string;
  name: string;
  regeneratable: boolean = null;
  updateTime: Date;
  uploadTime: Date;
  url: string;
  userId: number = null;
}
